import { UserOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/master-admin',
  redirect: '/account-master',
  name: 'MasterAdmin',
  component: Layout,
  meta: {
    title: 'master_management',
    root: true,
    auth: AUTH_KEYS.MASTER_ADMIN,
    noBreadcrumb: true
  },
  children: [
    {
      path: '/account-master',
      name: 'AccountMaster',
      component: () => import('@/views/MasterAdmin/AccountMaster.vue'),
      meta: { title: 'account_master', auth: AUTH_KEYS.ACCOUNT_MASTER },
      children: [
        {
          path: '/account-master/update/:id',
          name: 'AccountInfoUpdate',
          component: () => import('@/views/AccountInfo/Index.vue'),
          meta: { title: 'account_master_update', auth: AUTH_KEYS.ACCOUNT_INFO, isHide: true }
        },
        {
          path: '/account-master/trans/update/:id',
          name: 'TransAccountInfoUpdate',
          component: () => import('@/views/TransAccountInfo/Index.vue'),
          meta: {
            title: 'account_master_update',
            auth: AUTH_KEYS.TRANS_ACCOUNT_INFO_REGISTER,
            isHide: true
          }
        },
        {
          path: '/account-master/register',
          name: 'AccountInfoRegister',
          component: () => import('@/views/AccountInfo/Index.vue'),
          meta: { title: 'account_master_register', auth: AUTH_KEYS.ACCOUNT_INFO, isHide: true }
        },
        {
          path: '/account-master/trans/register',
          name: 'TransAccountInfoRegister',
          component: () => import('@/views/TransAccountInfo/Index.vue'),
          meta: {
            title: 'account_master_register',
            auth: AUTH_KEYS.TRANS_ACCOUNT_INFO_REGISTER,
            isHide: true
          }
        }
      ]
    },
    {
      path: '/transport-and-disposal-operator-master',
      name: 'TransportAndDisposalOperatorMaster',
      component: () => import('@/views/MasterAdmin/TransportMaster/Index.vue'),
      meta: { title: 'Transport and disposal operator master', auth: AUTH_KEYS.WASTE_MASTER }
    },
    {
      path: '/waste-master',
      name: 'WasteMaster',
      component: () => import('@/views/MasterAdmin/WasteMaster/WasteMasterList.vue'),
      meta: { title: 'waste_master', auth: AUTH_KEYS.WASTE_MASTER }
    },
    {
      path: '/unit-of-measure-master',
      name: 'UnitOfMeasureMaster',
      component: () => import('@/views/MasterAdmin/UnitOfMeasureMaster.vue'),
      meta: { title: 'unit_of_measure_master', auth: AUTH_KEYS.UNIT_OF_MEASURE_MASTER }
    },
    {
      path: '/packaging-master',
      name: 'PackagingMaster',
      component: () => import('@/views/MasterAdmin/PackagingMaster.vue'),
      meta: { title: 'packing_form_master', auth: AUTH_KEYS.PACKAGING_MASTER }
    },
    {
      path: '/disposal-site-master',
      name: 'DisposalSiteMaster',
      component: () => import('@/views/MasterAdmin/DisposalSiteMaster.vue'),
      meta: { title: 'Disposal site master', auth: AUTH_KEYS.DISPOSAL_SITE_MASTER }
    }
  ]
};
